import React, { useEffect, useState } from "react";
import { Button, Input, Row, Space, Spin, Tabs } from "antd";
import {
  FONT,
  isAdmin,
  ROLE_ADMIN,
  ROLE_ADMIN_CUSTOMER,
  ROLE_USER,
  ROLE_USER_ADMIN,
} from "constants/index";

import { getUsers } from "services/user/user-service";
import UsersClient from "./users-client";
import { ArrowRight, Search } from "lucide-react";
import { notificationErroInternal } from "util/api-utils";

const UsersClientTab = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(null);

  useEffect(() => {
    refreshData();
  }, []);

  function refreshData() {
    setLoading(true);
    getData();
  }

  function getData() {
    let obj = {
      search: search,
    };

    if (search == null || search == "") {
      obj = {};
    }
    getUsers(obj)
      .then((res) => {
        setLoading(false);
        setData(res);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  return (
    <>
      <Row gutter={24} style={{ padding: "10px" }}>
        <Space>
          <Input
            placeholder="Pesquisar Usuário"
            onChange={(value) => setSearch(value.target.value)}
            suffix={<Search size={18} color="#e0e0e0" />}
            style={{ height: "40px" }}
            onPressEnter={refreshData}
          />

          <Button
            style={{ fontFamily: FONT }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Space>
      </Row>
      <Spin spinning={loading}>
        <Tabs
          defaultActiveKey="1"
          centered
          size="large"
          style={{ fontFamily: FONT }}
          items={[
            ...(isAdmin()
              ? [
                  {
                    label: "Administradores",
                    key: ROLE_ADMIN,
                    children: (
                      <UsersClient
                        users={data.filter((item) => item.role === ROLE_ADMIN)}
                        refreshData={refreshData}
                      />
                    ),
                  },
                ]
              : []),

            {
              label: `Professores`,
              key: ROLE_USER_ADMIN,
              children: (
                <UsersClient
                  users={data.filter((item) => item.role == ROLE_USER_ADMIN)}
                  refreshData={refreshData}
                />
              ),
            },
            {
              label: `Alunos`,
              key: ROLE_USER,
              children: (
                <UsersClient
                  users={data.filter((item) => item.role == ROLE_USER)}
                  refreshData={refreshData}
                />
              ),
            },
            ...(isAdmin()
              ? [
                  {
                    label: `Clientes`,
                    key: ROLE_ADMIN_CUSTOMER,
                    children: (
                      <UsersClient
                        users={data.filter(
                          (item) => item.role == ROLE_ADMIN_CUSTOMER
                        )}
                        refreshData={refreshData}
                      />
                    ),
                  },
                ]
              : []),
          ]}
        />
      </Spin>
    </>
  );
};
export default UsersClientTab;
